import type { UploadFailureReason, UploadProcessingStatus } from '../types/types.js';

/** Client-facing message type on the upload progress SSE stream. */
export const UPLOAD_PROGRESS_STATE_MESSAGE = 'state';

/** Internal pub/sub payload: this upload changed, watchers should recompute. Never reaches a client. */
export const UPLOAD_DIRTY_SIGNAL = 'dirty';

export interface UploadExtractionSnapshot {
  /** Identifies the extraction, not the file: two archives can share a basename. */
  extractionId: string;
  filename: string;
  totalEntries: number;
  completedEntries: number;
  isComplete: boolean;
}

export interface UploadProgressSnapshot {
  /**
   * Increments on every change to the upload. Prevent regression on out-of-order.
   */
  version: number;
  status: UploadProcessingStatus;
  totalFiles: number;
  hashedFiles: number;
  convertedFiles: number;
  duplicateCount: number;
  deduplicateDocuments: boolean;
  successfullyUploadedFileCount: number;
  unpackingSkippedCount: number;
  textFallbackCount: number;
  downloadedFiles: number;
  totalDownloadFiles: number;
  preparingFetchedCount: number;
  preparingTotalCount: number;
  extractions: UploadExtractionSnapshot[];
  failuresByReason: Partial<Record<UploadFailureReason, number>>;
}
